module.exports = __webpack_public_path__ + "img/isPro2_4.3a87c0f4.png";